module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_7_5.7f28aea4.png";